import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CommonDataModel } from '../common-data-model';
import { ControlContainer, NgForm } from '@angular/forms';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-phone-number-form',
    templateUrl: './phone-number-form.component.html',
    styleUrls: ['./phone-number-form.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    encapsulation: ViewEncapsulation.None,
})

export class PhoneNumberFormComponent implements OnInit {

    @Output() emitOnRemovePhone: EventEmitter<any> = new EventEmitter<any>();
    commonDataModel = new CommonDataModel();
    contactNumberList: Array<object> = [];
    phoneTypeList = this.commonDataModel.phoneTypeList;
    contactPhoneListModel = this.commonDataModel.contactPhoneListModel;
    commonConstants: typeof CommonConstants = CommonConstants;
    @Input() set childData(contactList: any) {
        this.contactNumberList = contactList.contactNumberList;
    }

    constructor() { }

    ngOnInit() {
    }

    onAddPhone(): void {
        if (this.contactNumberList.length < 3) {
            this.contactNumberList.push(Object.assign({}, this.contactPhoneListModel));
        }
    }

    onRemovePhone(i: number): void {
        this.contactNumberList.splice(i, 1);
        this.emitOnRemovePhone.emit(this.contactNumberList);
    }

    showPlaceholder(value: number) {
        switch (value) {
            case 2:
                return CommonConstants.contactListConstants.enterOfficePhone;
            case 3:
                return CommonConstants.contactListConstants.enterOtherPhone;
            case 4:
                return CommonConstants.contactListConstants.enterFax;
        }
    }

}
